import { render, staticRenderFns } from "./TemplateFieldtype.vue?vue&type=template&id=9d4771f0&"
import script from "./TemplateFieldtype.vue?vue&type=script&lang=js&"
export * from "./TemplateFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports